import { useListQuery, type Query } from "./query";
import { api } from "./api";

/** An account the signed-in person has standing in: they hold it, or they hold client-wide access.
 *
 *  THE ACCOUNT IS A SCOPE, NOT A PROPERTY OF A CAMPAIGN (0274). Client-wide access reaches every
 *  campaign under a client, including ones opened later, so the control for it cannot live on a
 *  campaign screen — Caleb: *"from inside a single campaign's interface affects the entire client's
 *  organization and that's a mismatch"*. This is what lets the shell offer that scope at all. */
export type Account = { org_id: string; name: string; is_holder: boolean; campaigns: number };

/** AN EMPTY LIST IS AN ANSWER, A FAILED REQUEST IS NOT.
 *
 *  A campaign-only manager genuinely has no account scope and the shell must simply not offer one.
 *  A 500 or a dropped connection means we do not know — and rendering that as "no account" would
 *  quietly tell an account holder they do not hold their own account. Query<T> keeps the two apart
 *  at the type level, which is why this returns the query rather than an array. */
export function useAccounts(): { query: Query<Account[]>; reload: () => void } {
  const { query, reload } = useListQuery<Account[]>(
    "accounts",
    async () => (await api<{ accounts: Account[] }>("/accounts")).accounts ?? [],
  );
  return { query, reload };
}
